import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import LawnCare from "@/pages/LawnCare";
import GutterWindow from "@/pages/GutterWindow";
import JunkRemoval from "@/pages/JunkRemoval";
import BeforeAfter from "@/pages/BeforeAfter";
import BookNow from "@/pages/BookNow";
import Contact from "@/pages/Contact";
import Pricing from "@/pages/Pricing";
import Estimate from "@/pages/Estimate";
import Areas from "@/pages/Areas";
import SuburbPage from "@/pages/SuburbPage";
import Admin from "@/pages/Admin";
import AdminScheduler from "@/pages/AdminScheduler";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let raf;
        const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
        raf = requestAnimationFrame(loop);
        return () => { cancelAnimationFrame(raf); lenis.destroy(); };
    }, []);

    return (
        <div className="App bg-bone font-body text-ink">
            <div className="noise-overlay" />
            <BrowserRouter>
                <HelmetProvider>
                <ScrollToTop />
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/lawn-care" element={<LawnCare />} />
                    <Route path="/gutter-window-cleaning" element={<GutterWindow />} />
                    <Route path="/junk-removal" element={<JunkRemoval />} />
                    <Route path="/before-after" element={<BeforeAfter />} />
                    <Route path="/book-now" element={<BookNow />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/estimate" element={<Estimate />} />
                    <Route path="/areas" element={<Areas />} />
                    <Route path="/areas/:slug" element={<SuburbPage />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/admin/scheduler" element={<AdminScheduler />} />
                </Routes>
                <Footer />
                <Toaster position="top-center" richColors />
                </HelmetProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
